<script setup>
import { ref, onBeforeMount, computed } from 'vue';
import logService from '../service/log-service.js';
import bookAppointmentImg from '../img/appointment_icon_light_purple.png'
import phoneImg from '../img/phone_icon_light_purple.png'

const props = defineProps({
    faoModelData: {
        type: Object
    },
    officesData: {
        type: Object
    },
    searchStringOrObject: {
        type: [String, Object]
    },
    queryParameters:{
      type: String
    },
    filterQueryPrams:{
      type: String
    }
})

let day = ref(0)
const emit = defineEmits(['jhNavFAOGoBack']);

onBeforeMount(() => {
    var date = new Date();
    day = date.getDay();
})

const searchString = computed(() => {
  return typeof(props.searchStringOrObject) != 'object' ? props.searchStringOrObject : '';
})

function navGoToOfficeURL(event, office) {
  if(event.target.className != "headerFAO-block__resultsCntr-result-call" 
    && event.target.className != "headerFAO-block__resultsCntr-result-book"){
    logService.eventLog("Clicked on office result");
    logCtaGAEvent();
    redirectToYext(office,"officeResult")
  }
}

const viewMoreOffices = (eventName, url) => {
    var queryParams= (props.queryParameters != null && props.queryParameters != '') ? '&' + props.queryParameters:'';

    logService.eventLog(eventName);
    try{
        window.location.href = `${props.faoModelData.officeYextDomain}${url}${queryParams}`;
    } catch(error){
        window.location.href = `/officelocator/?search=${searchString.value}&filterWallmart=false&filterOpenAllYear=false&filterSpanishSpeaking=false&filterRefundAdvance=false&filterTaxCourses=false`;
    };
}

    const getOfficeURL = (office, calledFrom) => {
        var makeAnAppointment = calledFrom === "bookAnAppointment" ? '#coconut' : '';
        var filterdQueryParams = (props.filterQueryPrams != null && props.filterQueryPrams != '' && calledFrom != "bookAnAppointment") ? '?' + props.filterQueryPrams : '';
        
        if (props.faoModelData.useYextURL) {
          try {
              var queryParams = (props.queryParameters != null && props.queryParameters != '') ? '?' + props.queryParameters : '';
              return `${office.YextUrl}${queryParams}${makeAnAppointment}`;
            } catch {
                return `/${office.DetailsUrl}${filterdQueryParams}${makeAnAppointment}`;
            }
        } else {
          return `/${office.DetailsUrl}${filterdQueryParams}${makeAnAppointment}`;
        }
    }

const redirectToYext=(office,calledFrom)=>{
      var officeURL = getOfficeURL(office,calledFrom); 
      window.location.href= officeURL;
}

function jhNavFAOGoBack(){
  emit('jhNavFAOGoBack', searchString.value)
}

function logBookAnAptEvent(eventName){
  logService.eventLog(eventName);
  logCtaGAEvent();
}

function logCtaGAEvent(){
  logService.pushGAEvent({
    event: 'cta_click', 
    asset_category: 'Office Finder', 
    asset_name: 'Book Appointment', 
    asset_location: 'Global Header'
  });
}

function logClickToCallEvents(eventName, office){
  logService.eventLog(eventName);
  logService.pushGAEvent({
    event : 'click_to_call',
    jh_phone_number : office.Phone != 'Unknown' ? office.Phone : '',
    call_category : 'Call an office',
    street_name: (office.Address1 ? (office.Address1 + ', ') : '') + (office.Address2 ? (office.Address2 + ', ') : ''),
    state_name : office.State,
    city_name : office.City,
    asset_category : 'Office Finder', 
    asset_location : 'Global Header'
  });
}
</script>

<template>
    <div class="headerFAO-block__resultsCntr">
        <div class="headerFAO-block__title">
            <a class="headerFAO-block__resultsCntr-back" @click="jhNavFAOGoBack" @keyup.enter="jhNavFAOGoBack" tabindex="0">
            </a><span v-html="faoModelData.officeResltsTitleFAO"></span>
        </div>

        <div v-for="office in props.officesData.Offices" :key="office">
            <div @click.stop="navGoToOfficeURL($event, office)" @keyup.enter="navGoToOfficeURL($event, office)" class="headerFAO-block__resultsCntr-result" tabindex="0"  v-bind:data-officeNumber="office.OfficeNumber"> 
                <p class="headerFAO-block__resultsCntr-result-miles">{{ office.Distance + ' mile' + (office.Distance < 1 ? '' : 's')}}</p>
                <p class="headerFAO-block__resultsCntr-result-addr"> {{ (office.Address1 ? (office.Address1 + ', ') : '') 
                    + (office.Address2 ? (office.Address2 + ', ') : '') 
                    + office.CityStateZip }}
                </p>
                <p class="headerFAO-block__resultsCntr-result-hours">
                    {{ office.isOfficeHoursTextOverrideEnabled ? office.officeHoursOverrideText 
                        : ((office.OfficeHours && office.OfficeHours[0] && office.OfficeHours[0].DayOfWeek.toLowerCase() === "monday")
                        ? () => {day -= 1; if(day == -1) day=6;} 
                        : (office.OfficeHours[day].Hours != "Closed" 
                            ? ('Open ' + office.OfficeHours[day].Hours + ' today (local time)') : office.OfficeHours[day].Hours)) 
                    }}
                </p>
                <div class="headerFAO-block__resultsCntr-result-details">
                    <a :href="getOfficeURL(office,'bookAnAppointment')"
                    class="headerFAO-block__resultsCntr-result-book"
                        @click="logBookAnAptEvent('Office results - Book an appointment link clicked')">
                        <img class="mr-2" :src="bookAppointmentImg" width="16" height="16" alt="">
                        Book an appointment
                    </a>
                    <a :href="'tel:' + ((office.Phone != 'Unknown') ? office.Phone : '')"
                        class="headerFAO-block__resultsCntr-result-call"
                        @click="logClickToCallEvents('Office results - Call link clicked', office)"
                      ><img class="mr-2" :src="phoneImg" width="15" height="16" alt="">
                      {{ office.Phone }}
                    </a>
                </div>

            </div>
        </div>
        <a @click="viewMoreOffices('Office results - View more clicked',`/office-locator/?search=${searchString}&filterWallmart=false&filterOpenAllYear=false&filterSpanishSpeaking=false&filterRefundAdvance=false&filterTaxCourses=false`)"
            aria-label="view more offices" class="headerFAO-block__resultsCntr-viewMoreLink"
            v-html="faoModelData.viewMoreButtonFAO">
        </a>
    </div>
</template>

<style scoped>
  .headerFAO-block__resultsCntr-back {
    position: absolute;
    left: 0;
    top: 25%;
    padding: 0 calc(10px + 5px);
    cursor: pointer;
  }
  @media (max-width: 991px) {
    .headerFAO-block__resultsCntr-back {
      top: 0;
    }
  }
  .headerFAO-block__resultsCntr-back:before {
    content: url(../img/mobile_nav_icon_chevron_left.svg);
  }
  .headerFAO-block__resultsCntr-back:before:hover,
  .headerFAO-block__resultsCntr-back:before:active,
  .headerFAO-block__resultsCntr-back:before:focus {
    transition: all 0.1s ease-in-out;
    transform: translate(-0.3125rem, 0);
  }
  .headerFAO-block__resultsCntr-back:hover:before,
  .headerFAO-block__resultsCntr-back:active:before,
  .headerFAO-block__resultsCntr-back:focus:before {
    transition: all 0.1s ease-in-out;
    transform: translate(-0.3125rem, 0);
  }
.headerFAO-block__resultsCntr-back:hover,
.headerFAO-block__resultsCntr-back:active,
.headerFAO-block__resultsCntr-back:focus {
  transform: scale(1.3);
}
.headerFAO-block__resultsCntr-back:focus-visible {
    outline: none;
  }

  .headerFAO-block__resultsCntr-viewMoreLink {
    background: #F6F6F6;
    color: #505050;
    --errorColor: #D90000;
    cursor: pointer;
    font-family: OpenSans-SemiBold;
    text-decoration: none;
    color: #633981;
    padding: 10px 20px;
    display: inline-block;
    width: 100%;
  }
  .headerFAO-block__resultsCntr-viewMoreLink:hover,
  .headerFAO-block__resultsCntr-viewMoreLink:active,
  .headerFAO-block__resultsCntr-viewMoreLink:focus {
    text-decoration: underline;
    color: #1878CC;
  }
  .headerFAO-block__resultsCntr-viewMoreLink:hover,
  .headerFAO-block__resultsCntr-viewMoreLink:active,
  .headerFAO-block__resultsCntr-viewMoreLink:focus {
    color: #633981;
  }
  .headerFAO-block__resultsCntr-viewMoreLink:focus-visible{
    outline: none;
  }
  @media (max-width: 991px) {
    .headerFAO-block__resultsCntr-viewMoreLink {
      box-shadow: rgba(0, 0, 0, 0.35) 7px 0 9px -7px inset;
    }
  }
  .headerFAO-block__resultsCntr-result {
    width: 100%;
    display: inline-block;
    border-top: 1px solid #E0E0E0;
    padding: 20px 30px 20px 20px;
    position: relative;
    cursor: pointer;
  }
  .headerFAO-block__resultsCntr-result:focus-visible {
    outline: none;
  }
  .headerFAO-block__resultsCntr-result-miles {
    font-size: 0.813em;
    line-height: 1.5em;
    letter-spacing: 0.138em;
    text-transform: uppercase;
    font-family: OpenSans-SemiBold;
    color: #1878CC;
  }
  @media only screen and (min-width: 992px) {
    .headerFAO-block__resultsCntr-result-miles {
      font-size: 0.75em;
      letter-spacing: 2px;
    }
  }
  .headerFAO-block__resultsCntr-result-miles a.link-inline {
    color: #360060;
  }
  .headerFAO-block__resultsCntr-result-addr {
    font-weight: inherit;
    font-family: OpenSans-SemiBold;
    margin-top: 5px;
  }
  .headerFAO-block__resultsCntr-result-hours {
    margin-top: 5px;
  }
  .headerFAO-block__resultsCntr-result-details {
    margin-top: 5px;
    display: -ms-flexbox;
    display: flex;
    -ms-flex-direction: row;
        flex-direction: row;
    -ms-flex-pack: justify;
        justify-content: space-between;
    -ms-flex-align: start;
        align-items: start;
  }
  .headerFAO-block__resultsCntr-result-details a {
    font-size: 0.875em;
    line-height: 1.5em;
    cursor: pointer;
    font-family: OpenSans-SemiBold;
    text-decoration: none;
    color: #633981;
    display: -ms-flexbox;
    display: flex;
    -ms-flex-align: center;
        align-items: center;
  }
  @media only screen and (min-width: 992px) {
    .headerFAO-block__resultsCntr-result-details a {
      font-size: 0.75em;
    }
  }
  .headerFAO-block__resultsCntr-result-details a:hover,
  .headerFAO-block__resultsCntr-result-details a:active,
  .headerFAO-block__resultsCntr-result-details a:focus {
    text-decoration: underline;
    color: #1878CC;
  }
  .headerFAO-block__resultsCntr-result-details a:hover,
  .headerFAO-block__resultsCntr-result-details a:active,
  .headerFAO-block__resultsCntr-result-details a:focus {
    color: #633981;
  }
  .headerFAO-block__resultsCntr-result-details a:focus-visible {
    outline: none;
  }
  .headerFAO-block__resultsCntr-result:before {
    position: absolute;
    content: url(../img/mobile_nav_icon_chevron_right.svg);
    bottom: 40%;
    right: 5px;
    display: inline-block;
    padding-right: 0.5em;
    vertical-align: middle;
  }
  .headerFAO-block__resultsCntr-result:hover:before,
  .headerFAO-block__resultsCntr-result:active:before,
  .headerFAO-block__resultsCntr-result:focus:before {
    transition: all 0.1s ease-in-out;
    transform: translate(0.3125rem, 0);
  }
</style>